var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news_w" }, [
    _c("div", { staticClass: "courseL" }, [
      _c("div", { staticClass: "list" }, [
        _c("div", { staticClass: "locationBox" }, [
          _c("img", {
            attrs: { src: require("@/assets/img/icon-position.png") },
          }),
          _vm._v(" "),
          _c("div", [
            _vm._v("您当前位置: "),
            _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    return _vm.$router.push("/reNews")
                  },
                },
              },
              [_vm._v("新闻公告 ")]
            ),
            _vm._v("> " + _vm._s(_vm.typeName) + " > 详情"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "main" }, [
          _c("div", { staticClass: "tit" }, [
            _vm._v(_vm._s(_vm.newsInfo.newsTitle)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "time" }, [
            _vm._v("发布日期：" + _vm._s(_vm.newsInfo.createTime)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", {
            staticClass: "content ql-editor",
            domProps: { innerHTML: _vm._s(_vm.richContent) },
          }),
          _vm._v(" "),
          _vm.uploadFileList.length > 0
            ? _c(
                "div",
                { staticClass: "fjList" },
                _vm._l(_vm.uploadFileList, function (file, j) {
                  return _c("div", { staticClass: "fj" }, [
                    _c(
                      "a",
                      {
                        attrs: { target: "_blank" },
                        on: {
                          click: function ($event) {
                            return _vm.downloadIcveFile(
                              file.ossOriUrl,
                              file.fileName
                            )
                          },
                        },
                      },
                      [
                        _vm._v("附件" + _vm._s(j + 1) + "："),
                        _c("span", [_vm._v(_vm._s(file.fileName))]),
                      ]
                    ),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _vm.front && _vm.front.newsTitle
            ? _c(
                "div",
                {
                  staticClass: "next",
                  on: {
                    click: function ($event) {
                      return _vm.changeNews(_vm.front.id)
                    },
                  },
                },
                [
                  _vm._v("\n          上一篇："),
                  _c("span", [_vm._v(_vm._s(_vm.front.newsTitle))]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.next && _vm.next.newsTitle
            ? _c(
                "div",
                {
                  staticClass: "fj",
                  on: {
                    click: function ($event) {
                      return _vm.changeNews(_vm.next.id)
                    },
                  },
                },
                [
                  _vm._v("\n          下一篇："),
                  _c("span", [_vm._v(_vm._s(_vm.next.newsTitle))]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }